import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";

const SocialIcons = dynamic(() => import("@/common/Header/socialIcon"));
const Button = dynamic(() => import("@/common/UI/Button"));
const MenuItem = dynamic(() => import("@/common/Header/MenuItem"));
const Logo = dynamic(() => import("@/components/common/Logo"));

import { withIsMobile } from "@/hooks/withIsMobile";

function Header(props) {
  const { isMobile, labelsList, siteConfig, menuList } = props;

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    let body = document.getElementById("bodyEl");
    isMenuOpen
      ? body.classList.add("overflow-hidden")
      : body.classList.remove("overflow-hidden");
  }, [isMenuOpen]);

  const openMobileMenu = (flag, type = "") => {
    setIsMenuOpen(flag);
    if (type === "form") {
      let contantLink = document.getElementById("typeformbtn");
      contantLink ? contantLink?.click() : null;
    }
  };

  return (
    <>
      {siteConfig && (
        <Head>
          <script defer src="//embed.typeform.com/next/embed.js"></script>
        </Head>
      )}

      <nav className={`lg:flex items-center pt-8 pb-4 bg-white`}>
        <div className="w-full px-2 xxl:px-8">
          <div className="container md:max-w-4xl lg:max-w-none">
            <div className="flex items-center justify-between">
              <div className="mx-auto mt-4 md:mt-0 md:mx-0 contain-image">
                <Logo
                  imageSrc={siteConfig?.logoHeader?.webp}
                  imageAlt={siteConfig?.logoHeader?.alt}
                  imageTitle={siteConfig?.logoHeader?.title}
                  height={120}
                />
              </div>
              {!isMobile && (
                <div className="flex flex-col items-center lg:pl-2">
                  <MenuItem
                    menu={siteConfig?.subMenuList}
                    customClass={
                      "min-w-full pb-4 justify-end items-center hidden md:flex"
                    }
                    linkClass={"px-3 h4-web hover:text-themeHover"}
                    socialIcon={true}
                    siteConfig={siteConfig}
                    labelsList={labelsList}
                    closeMenu={() => openMobileMenu(false)}
                    menuList={menuList}
                  />

                  {!isMobile && (
                    <MenuItem
                      menu={siteConfig?.mainMenuList}
                      customClass={"lg:flex hidden items-center py-4"}
                      linkClass={
                        "px-2 xl:px-4 uppercase tracking-[0.1rem] h6-web hover:text-themeHover focus:text-themePress inline-block text-center"
                      }
                      contactBtn={true}
                      siteConfig={siteConfig}
                      labelsList={labelsList}
                      closeMenu={() => openMobileMenu(false)}
                      menuList={menuList}
                    />
                  )}
                </div>
              )}
            </div>
            {!isMobile && (
              <MenuItem
                menu={siteConfig?.mainMenuList}
                customClass={
                  "md:flex justify-between items-center hidden lg:hidden mt-4"
                }
                linkClass={
                  "px-2 uppercase h6-web tracking-[0.1rem] hover:text-themeHover focus:text-themePress align-text-bottom inline-block text-center"
                }
                contactBtn={true}
                siteConfig={siteConfig}
                labelsList={labelsList}
                closeMenu={() => openMobileMenu(false)}
                menuList={menuList}
              />
            )}
          </div>
        </div>

        {isMobile && (
          <>
            {/* Mobile Menu */}
            {!isMenuOpen && (
              <div className="absolute w-full top-0 left-0 right-0 md:hidden">
                <div className="flex items-center justify-between">
                  <SocialIcons
                    customClass={"pl-3 inline-flex"}
                    siteConfig={siteConfig}
                  />
                  <Button
                    onClick={() => openMobileMenu(true)}
                    style={{
                      backgroundColor: siteConfig?.brandButtonDefaultColor?.hex,
                    }}
                    className="text-white w-14 h-14 flex justify-center items-center fixed top-0 z-[10] right-5 shadow-md"
                  >
                    <iconify-icon icon="fa:bars" width="26"></iconify-icon>
                  </Button>
                </div>
              </div>
            )}
            <button
              id="typeformbtn"
              data-tf-slider={siteConfig?.typeformId}
              data-tf-width="450"
              data-tf-medium="snippet"
              className="absolute top-12 text-white"
            >
              {labelsList?.contactUs}
            </button>

            {isMenuOpen && (
              <div
                style={{
                  backgroundColor: siteConfig?.brandButtonPressedColor?.hex,
                }}
                className="fixed inset-0 w-screen h-screen text-right pr-6 z-[12]"
              >
                <div
                  className="text-right inline-block pt-3 relative -right-4"
                  onClick={() => openMobileMenu(false)}
                >
                  <iconify-icon
                    icon="ci:close-small"
                    width="60"
                    style={{ color: "white" }}
                  ></iconify-icon>
                </div>
                <div>
                  <MenuItem
                    menu={siteConfig?.mainMenuList}
                    customClass={""}
                    linkClass={"block text-white h2-web first:leading-[3.5rem]"}
                    siteConfig={siteConfig}
                    labelsList={labelsList}
                    contactText={true}
                    closeMenu={(value) => openMobileMenu(false, value)}
                    menuList={menuList}
                  />
                  <MenuItem
                    menu={siteConfig?.subMenuList}
                    customClass={"my-10 "}
                    linkClass={"block text-white h3-web py-2"}
                    siteConfig={siteConfig}
                    labelsList={labelsList}
                    closeMenu={(value) => openMobileMenu(false, value)}
                    menuList={menuList}
                  />
                  <SocialIcons
                    customClass={false}
                    iconColor="white"
                    linkClass="mx-4"
                    customColor={true}
                    siteConfig={siteConfig}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </nav>
    </>
  );
}

export default withIsMobile(Header);
